import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from 'yup';
import commonFormMeta from "../commonMeta";
import { BankIDInputMeta, CorporateNameInputMeta } from '../commonMeta';

export interface ICommissionSettingsMeta {
  bankID: FormInputMeta,
  corporateName: FormInputMeta,
  mccGroup: FormInputMeta,
  mailInternetOrder: FormInputMeta,
  cardUsage: FormInputMeta,
  transactionType: FormInputMeta,
  transactionCode: FormInputMeta,
  paymentChannel: FormInputMeta,
  bankGroup: FormInputMeta,
  schema: any,
}

const commissionSettingsMeta = {} as ICommissionSettingsMeta;

commissionSettingsMeta.mccGroup = commonFormMeta.mccGroup;

commissionSettingsMeta.mailInternetOrder = {
  label: "Mail Order / Internet Order",
  name: "mailInternetOrderMeta",
  type: "text",
  validation: yup.string().required(),
}
commissionSettingsMeta.cardUsage = commonFormMeta.cardUsage;

commissionSettingsMeta.transactionType = commonFormMeta.transactionType

commissionSettingsMeta.transactionCode = commonFormMeta.transactionCode

commissionSettingsMeta.bankID = BankIDInputMeta;

commissionSettingsMeta.corporateName = CorporateNameInputMeta;

commissionSettingsMeta.paymentChannel = {
  label: "Payment Channel",
  name: "paymentChannel",
  type: "text",
  validation: yup.string(),
}

commissionSettingsMeta.bankGroup = commonFormMeta.bankGroup

commissionSettingsMeta.schema = yup.object().shape(getValidationSchema(commissionSettingsMeta));

export default commissionSettingsMeta;